import { HeroIcon } from '@components/HeroIcon'
import { Modal } from '@components/Modal'
import { XStack, YStack, Separator, Stack } from 'tamagui'
import { ConfigItemText } from './ConfigsModal'
import { PlaybackRateOption } from './VideoPlayer'
import { HeroRadio } from '@components/HeroRadio'
import { useWhenShouldModalAdapt } from '@hooks/useWhenShouldModalAdapt'
import { Pressable } from 'react-native'

interface IPlaybackRateSelectorProps {
  open: boolean
  onClose: () => void
  playbackRateOptions: PlaybackRateOption[]
  onPlaybackRateChange: (rate: number) => void
  currentPlaybackRate: number
}

export function PlaybackRateSelector({
  open,
  onClose,
  playbackRateOptions,
  onPlaybackRateChange,
  currentPlaybackRate,
}: IPlaybackRateSelectorProps) {
  const { whenShouldAdapt } = useWhenShouldModalAdapt()
  const handleValueChange = (value: string) => {
    const playbackRateOption = playbackRateOptions.find(
      (playbackRateOption) => playbackRateOption.value.toString() === value,
    )
    if (playbackRateOption) {
      onPlaybackRateChange(playbackRateOption.value)
    }
  }

  return (
    <Modal
      onClose={onClose}
      open={open}
      snapPointsMode="fit"
      backdropOpacity={0.9}
      whenShouldAdapt={whenShouldAdapt ?? 'sm'}
      zIndex={100000000}
    >
      <XStack
        gap="$spacing-inset-nano"
        alignItems="center"
        p="$spacing-inset-md"
        justifyContent="center"
      >
        <HeroIcon icon={'video-speed'} color="$neutral-800" size={24} />
        <ConfigItemText>Velocidade de reprodução</ConfigItemText>
      </XStack>
      <Separator
        borderColor="$neutral-300"
        borderWidth="$border-width-hairline"
      />
      <YStack padding="$spacing-inset-md" gap="$spacing-inset-xs">
        {playbackRateOptions.map((playbackRateOption) => (
          <Stack justifyContent="center" key={playbackRateOption.value}>
            <Pressable
              key={playbackRateOption.value}
              style={{
                backgroundColor: 'transparent',
                zIndex: 2,
                width: 100,
                height: '100%',
                position: 'absolute',
              }}
              onPressIn={() =>
                handleValueChange(playbackRateOption.value.toString())
              }
            />
            <HeroRadio
              size={29}
              options={[
                {
                  name: playbackRateOption.label,
                  value: playbackRateOption.value.toString(),
                },
              ]}
              style={{
                zIndex: 1,
              }}
              value={currentPlaybackRate.toString()}
            />
          </Stack>
        ))}
      </YStack>
    </Modal>
  )
}
